import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Button,
  CircularProgress
} from '@mui/material';
import { Close as CancelIcon, Check as ConfirmIcon } from '@mui/icons-material';

/**
 * RejectionDialog component for collecting rejection reason
 * Modal dialog that prompts for a rejection reason before rejecting a suggestion
 */
const RejectionDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  title = 'Reject Suggestion',
  description = 'Please provide a reason for rejecting this suggestion. This will help the user understand why their submission was not approved.'
}) => {
  const [reason, setReason] = React.useState('');

  const handleConfirm = () => {
    onConfirm(reason);
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {description}
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          label="Rejection Reason"
          placeholder="Enter the reason for rejection..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={loading}
          required
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          startIcon={<CancelIcon />}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading || !reason.trim()}
          startIcon={loading ? <CircularProgress size={16} /> : <ConfirmIcon />}
        >
          {loading ? 'Rejecting...' : 'Confirm Rejection'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectionDialog;
